var SupportBasePresentation, SupportGetawaysBookingPresenterPresentation, SupportGetawaysBookingStatusAndNotesPresentation, SupportPresenterUtilPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportPresenterUtilPresentation = require('./presenter_util');

SupportGetawaysBookingStatusAndNotesPresentation = require('./getaways_booking_messages');

SupportGetawaysBookingPresenterPresentation = (function(superClass) {
  extend(SupportGetawaysBookingPresenterPresentation, superClass);

  function SupportGetawaysBookingPresenterPresentation() {
    return SupportGetawaysBookingPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportGetawaysBookingPresenterPresentation.prototype.getLookupObject = function() {
    return SupportGetawaysBookingStatusAndNotesPresentation;
  };

  SupportGetawaysBookingPresenterPresentation.prototype.getLookupKeySequence = function() {
    var keys;
    keys = [];
    if (this.order != null) {
      keys.push(SupportPresenterUtilPresentation.prototype.getEditableKey(this.order.isEditable));
      keys.push(SupportPresenterUtilPresentation.prototype.getGetawaysBookingStatus(this.order));
    }
    return SupportPresenterUtilPresentation.prototype.concatenateLookupKeys(keys);
  };

  return SupportGetawaysBookingPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportGetawaysBookingPresenterPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9nZXRhd2F5c19ib29raW5nX3ByZXNlbnRlci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9wcmVzZW50ZXJzL2dldGF3YXlzX2Jvb2tpbmdfcHJlc2VudGVyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHdKQUFBO0VBQUE7OztBQUFBLHVCQUFBLEdBQTBCLE9BQUEsQ0FBUSxRQUFSOztBQUMxQixnQ0FBQSxHQUFtQyxPQUFBLENBQVEsa0JBQVI7O0FBQ25DLGdEQUFBLEdBQW1ELE9BQUEsQ0FBUSw2QkFBUjs7QUFFN0M7Ozs7Ozs7d0RBQ0osZUFBQSxHQUFpQixTQUFBO1dBQ2Y7RUFEZTs7d0RBR2pCLG9CQUFBLEdBQXNCLFNBQUE7QUFDcEIsUUFBQTtJQUFBLElBQUEsR0FBTztJQUVQLElBQUcsa0JBQUg7TUFDSSxJQUFJLENBQUMsSUFBTCxDQUFVLGdDQUFnQyxDQUFBLFNBQUUsQ0FBQSxjQUFsQyxDQUFpRCxJQUFDLENBQUEsS0FBSyxDQUFDLFVBQXhELENBQVY7TUFDQSxJQUFJLENBQUMsSUFBTCxDQUFVLGdDQUFnQyxDQUFBLFNBQUUsQ0FBQSx3QkFBbEMsQ0FBMkQsSUFBQyxDQUFBLEtBQTVELENBQVYsRUFGSjs7V0FHQSxnQ0FBZ0MsQ0FBQSxTQUFFLENBQUEscUJBQWxDLENBQXdELElBQXhEO0VBTm9COzs7O0dBSmtDOztBQVkxRCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
